import { createTransformKeyFrame } from './transform';

const IN = 'scale-in';
const OUT = 'scale-out';

createTransformKeyFrame(IN, 'scale(0)', 'scale(1)');
createTransformKeyFrame(OUT, 'scale(1)', 'scale(0)');

export const SCALE = { IN, OUT };
